module.exports = __webpack_public_path__ + "static/media/favicon.ba50eb78.ico";